import React, { useState, useEffect } from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import { getWidgetTypeProps } from '@/components/Widgets';
import OmniPicker from '@/components/OmniPicker';
import IconItemOptions from './IconItemOptions';
import WidgetOptionsForm from '../WidgetOptionsForm';
import WidgetOptionGroupPermissions from '../WidgetOptionGroupPermissions';
import { normalizeRepeatedItems, updateRepeatedItem } from '../repeatedWidgetItems';

const iconWidgetDefaultProps = getWidgetTypeProps('Icon');
const createDefaultIcon = () => ({ ...(iconWidgetDefaultProps.icons?.[0] || {}) });

const IconWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		widgetProps,
		setOmniPicker,
		omniPicker,
		handlePickMedia,
		handleChange,
		syncWidgetChange,
		handleGroupChange,
		targetKeys,
	} = props;
	const { amount = '1' } = widgetProps;
	const [iconProps, setIconProps] = useState([]);

	useEffect(() => {
		const normalizedIcons = normalizeRepeatedItems(
			widgetProps.icons || [],
			amount,
			createDefaultIcon
		);
		setIconProps(normalizedIcons);
	}, [widgetProps, amount]);

	const updateIcon = (index, patch) => {
		setIconProps(currentIcons => {
			const nextIcons = updateRepeatedItem(currentIcons, index, patch, createDefaultIcon);
			syncWidgetChange({ ...widgetProps, icons: nextIcons });
			return nextIcons;
		});
	};

	const updateIconField = (index, key, value) => updateIcon(index, { [key]: value });

	const handlePickOmniItem = (pickedLink, index) => {
		updateIconField(index, 'onPress', pickedLink);
		setOmniPicker({ open: false, mediaPicker: false, from: '', index: null });
	};

	return (
		<>
			<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
				<Form.Item label="Number of Icons in Row" name="amount">
					<Toggle toggleOptions={['1', '2', '3', '4']} />
				</Form.Item>
				<Form.Item label="Icon Size" name="size">
					<Toggle toggleOptions={['small', 'large', 'full']} />
				</Form.Item>
				{widgetProps.size !== 'full' ? (
					<Form.Item label="Icon Alignment" name="alignment">
						<Toggle toggleOptions={['left', 'center', 'right', 'spaced']} />
					</Form.Item>
				) : null}
				{iconProps.map((icon, index) => (
					<IconItemOptions
						{...props}
						icon={icon}
						index={index}
						updateIconField={updateIconField}
						handlePickOmniItem={handlePickOmniItem}
						key={`icon-item-option-${index}`}
					/>
				))}
				<WidgetOptionGroupPermissions
					event={event}
					handleGroupChange={handleGroupChange}
					targetKeys={targetKeys}
				/>
			</WidgetOptionsForm>
			<OmniPicker
				event={event}
				visible={omniPicker.open}
				onCancel={() => setOmniPicker({ open: false, mediaPicker: false, from: '', onPress: {} })}
				handlePickItem={pickedLink => handlePickOmniItem(pickedLink, omniPicker.index)}
				handlePickMedia={handlePickMedia}
				mediaPicker={omniPicker.mediaPicker}
				onPress={omniPicker.onPress}
				from={omniPicker.from}
			/>
		</>
	);
};

export default IconWidgetOptions;
